import { useEffect, useState } from "react";
import { api, makeBackendFileUrl } from "../lib/api";
import RoomCard from "./RoomCard";
import BookingDialog from "./BookingDialog";

export default function RoomsSection() {
  const [rooms, setRooms] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedRoom, setSelectedRoom] = useState(null);

  useEffect(() => {
    api
      .get("/rooms")
      .then((res) => setRooms(res.data || []))
      .catch(() => setRooms([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <section id="stays" data-testid="stays-section" className="py-24 md:py-32 bg-background paper-texture">
      <div className="container mx-auto px-6 md:px-12 max-w-7xl">
        <div className="max-w-2xl mb-16">
          <p className="overline mb-4">Our Stay Options</p>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-foreground font-medium leading-[1.05] tracking-tight">
            Four distinct suites, one warm home in the hills.
          </h2>
          <p className="mt-6 font-sans text-base text-muted-foreground max-w-xl">
            Each unit is independently designed with private entry, 24×7 hot water and the kind of
            quiet only Coorg can offer. Check live availability and reserve with a 25% advance.
          </p>
        </div>

        {loading ? (
          <div className="grid md:grid-cols-2 gap-8" data-testid="rooms-loading">
            {[0, 1, 2, 3].map((i) => (
              <div key={i} className="h-[420px] rounded-2xl bg-muted/60 animate-pulse" />
            ))}
          </div>
        ) : (
          <div className="grid md:grid-cols-2 gap-8 md:gap-12">
            {rooms.map((room, idx) => (
              <RoomCard
                key={room.id}
                room={{
                  ...room,
                  photos: (room.photos || []).map(makeBackendFileUrl),
                }}
                emphasis={idx % 3 === 0}
                onBook={() => setSelectedRoom(room)}
              />
            ))}
          </div>
        )}
      </div>

      <BookingDialog
        room={selectedRoom}
        open={!!selectedRoom}
        onOpenChange={(v) => !v && setSelectedRoom(null)}
      />
    </section>
  );
}
